export const PILEUS_ROLE_FILENAME = 'PileusRole.json';
export const PILEUS_POLICY_FILENAME = 'PileusPolicy.json';
export const AUTOMATIC_ONBOARDING_SCRIPT_HELPER = 'AnodotPayer.yaml';
export const AUTOMATIC_ONBOARDING_LINKED_ACCOUNTS_SCRIPT_HELPER = 'AnodotLinkedRecursive.yaml';
export const AUTOMATIC_ONBOARDING_SCRIPT = 'deploy_anodot.sh';
export const NEW_INVOICE_TOPIC_FILENAME = 'NewInvoiceTopicConfiguration.json';
export const getConnectToFile = (accountId) => `${accountId}_connect_to_pileus.txt`;
export const MAX_ASSUME_ROLE_SESSION_DURATION_IN_SECONDS = 10800;
